<div [formGroup]="form" autocomplete="off" #formElement>
  <div
    [ngSwitch]="attribute?.controlType"
    class="leg-attribute leg-attribute-{{ attribute.key }}"
  >
    <ng-container *ngSwitchCase="'textbox'">
      <input-with-spinner
        [inputValidatorKey]="attribute.validator"
        [required]="attribute.required"
        [formControlName]="attribute.key"
        [id]="attribute.key"
        [type]="attribute.type"
        [readOnly]="attribute.readOnly"
        [flashOnChange]="attribute.flashOnChange"
        [info]="attribute.info"
        [textColor]="attribute.textColor"
        [title]="attribute.title"
      ></input-with-spinner>
    </ng-container>
    <div class="select" *ngSwitchCase="'dropdown'">
      <app-selector
        [passedItems]="attribute.options"
        [formControlName]="attribute.key"
        [isSearch]="isSearchable(attribute.key)"
        [isCross]="isCross"
        [id]="attribute.key"
        [textColor]="attribute.textColor"
        [readonly]="attribute.readOnly"
        [info]="attribute.info"
        [title]="attribute.title"
        (valueEmitter)="dropdownChange($event)"
      ></app-selector>
    </div>
    <div class="select" *ngSwitchCase="'multiSelect'">
      <app-selector
        [passedItems]="attribute.options"
        [formControlName]="attribute.key"
        [isSearch]="true"
        [isCross]="false"
        [id]="attribute.key"
        [readonly]="attribute.readOnly"
        [multiSelect]="true"
        [closeOnSelect]="false"
        [textColor]="attribute.textColor"
        [info]="attribute.info"
        [title]="attribute.title"
      ></app-selector>
    </div>

    <ng-container *ngSwitchCase="'editableDate'">
      <date-with-spinner-info
        class="no-top-margin"
        [inputValidatorKey]="attribute.validator"
        [required]="attribute.required"
        [formControlName]="attribute.key"
        [id]="attribute.key"
        [readOnly]="attribute.readOnly"
        [info]="attribute.info"
        [format]="'D MMM YYYY'"
        [title]="attribute.title"
      ></date-with-spinner-info>
    </ng-container>

    <ng-container *ngSwitchCase="'date'">
      <date-with-spinner-info
        class="no-top-margin"
        [inputValidatorKey]="attribute.validator"
        [required]="attribute.required"
        [formControlName]="attribute.key"
        [id]="attribute.key"
        [readOnly]="attribute.readOnly"
        [info]="attribute.info"
        [format]="'D MMM YYYY'"
        [title]="attribute.title"
      ></date-with-spinner-info>
    </ng-container>

    <ng-container *ngSwitchCase="'bidAskList'">
      <div class="bidAskList bidAskList-{{ attribute.key }}">
        <ng-container
          *ngFor="let bidAskAttribute of attribute.attributes; let i = index"
        >
          <input-with-spinner
            [inputValidatorKey]="bidAskAttribute.validator"
            [required]="bidAskAttribute.required"
            [formControlName]="bidAskAttribute.key"
            [id]="bidAskAttribute.key"
            [type]="bidAskAttribute.type"
            [readOnly]="bidAskAttribute.readOnly"
            [useBasicTextBox]="true"
            [title]="bidAskAttribute.title"
            [textColor]="bidAskAttribute.textColor"
            (onBlur)="onBlur()"
            (onFocus)="onFocus(bidAskAttribute.key)"
          ></input-with-spinner>

          <span *ngIf="i === 0" class="field-separator">/</span>
        </ng-container>
        <div
          class="icon-wrapper"
          *ngIf="!isValidTmpl && fieldTouched"
          [title]="bidAskListError"
        >
          <cds-icon class="alert-icon" shape="exclamation-circle"></cds-icon>
        </div>
      </div>
    </ng-container>

    <button
      *ngSwitchCase="'button'"
      type="button"
      [id]="attribute.key"
      [ngClass]="[attribute.key, isValid ? 'valid' : 'in-valid']"
      [title]="attribute.title"
      (click)="emitOnButtonClicked()"
    >
      {{ attribute.info }}
      <img [src]="attribute.imageSrc" />
    </button>
  </div>
</div>
